import React from 'react'

// Import only the flags this product uses as URL assets. The library's default
// component embeds every world flag (~3.6 MB) in the initial JavaScript bundle.
const files = import.meta.glob('/node_modules/react-world-flags/src/svgs/{at,be,ch,de,dk,es,eu,fi,fr,gb,it,nl,pl,pt,ro,se}.svg', { eager: true, query: '?url', import: 'default' })
const flags = Object.fromEntries(Object.entries(files).map(([path, url]) => [path.split('/').pop().replace('.svg', '').toUpperCase(), url]))

export default function CountryFlag({ code, alt = '', ...props }) {
  const key = String(code || '').toUpperCase().replace(/^UK$/, 'GB')
  const src = flags[key]
  return src ? <img {...props} src={src} alt={alt} aria-hidden={alt ? undefined : true} /> : <span {...props}>{key}</span>
}
